"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Faq = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Faq(props) {
    var _this;
    _classCallCheck(this, Faq);
    _this = _callSuper(this, Faq, [props]);
    _defineProperty(_this, "state", {
      hideOverflow: true
    });
    _defineProperty(_this, "toggleMore", function () {
      _this.setState({
        hideOverflow: !_this.state.hideOverflow
      });
    });
    _this.toggleMore = _this.toggleMore.bind(_this);
    return _this;
  }
  _inherits(Faq, _React$Component);
  return _createClass(Faq, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        questions = _this$props.questions,
        limit = _this$props.limit,
        headerText = _this$props.headerText,
        showMoreText = _this$props.showMoreText,
        showFewerText = _this$props.showFewerText;
      var hideOverflow = this.state.hideOverflow;
      var qCount = questions.length;
      var main = [];
      var overflow = [];
      var item = '';
      if (qCount < 1) {
        return /*#__PURE__*/_react["default"].createElement("div", null);
      }
      for (var i = 0; i < qCount; i++) {
        item = /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].item,
          key: i
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].question
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].q
        }, "Q."), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: questions[i].question
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].answer
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].a
        }, "A."), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: questions[i].answer
        })), /*#__PURE__*/_react["default"].createElement("hr", null));
        if (limit > 0 && i < limit) {
          main.push(item);
        } else {
          overflow.push(item);
        }
      }
      if (overflow.length === 0) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].faq
        }, /*#__PURE__*/_react["default"].createElement("h4", null, headerText), main);
      }
      if (hideOverflow) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].faq
        }, /*#__PURE__*/_react["default"].createElement("h4", null, headerText), main, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].controls
        }, /*#__PURE__*/_react["default"].createElement("a", {
          onClick: this.toggleMore
        }, showMoreText)));
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].faq
      }, /*#__PURE__*/_react["default"].createElement("h4", null, headerText), main, overflow, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].controls
      }, /*#__PURE__*/_react["default"].createElement("a", {
        onClick: this.toggleMore
      }, showFewerText)));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Faq, "propTypes", {
  headerText: _propTypes["default"].string,
  showMoreText: _propTypes["default"].string,
  showFewerText: _propTypes["default"].string,
  questions: _propTypes["default"].array,
  limit: _propTypes["default"].number
});
_defineProperty(Faq, "defaultProps", {
  headerText: 'Frequently Asked Questions',
  showMoreText: 'Show more questions & answers...',
  showFewerText: 'Show fewer questions & answers...',
  questions: [],
  limit: 999999999
});